import { HttpStatus } from 'modules/core';
import { apiClient } from '../../../helpers/api_helper';

export const getAllStoreTypeForSelect = async () => {
    try {
        const response = await apiClient.get(`/api/v1/store/GetStoresSelectList`);
          if (response.status === HttpStatus.Success) {
              return response;
          }
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getStoreTypeById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/store/GetStoreDetailsById?id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};